/* ═══════════════════════════════════════════════════════════════════════════
   BRITT SISSECK — FIGMA LAUNCH BEHAVIOURS (19 Aug 2026)
   Port of the approved v4 preview interactions onto the live theme.

   1. PDP sticky panel fix — if the product information column is taller than
      the viewport, pin it so the BOTTOM (Add to Cart) is reachable instead of
      pinning the top offscreen.
   2. Hero logotype shrink — the white wordmark glides into the EXACT size
      and spot of the header logotype, rests there in white over the photo,
      turns black the moment the hero has scrolled past, and hands over to
      the real header logotype when the header appears.
   3. Statement pin — the landing line freezes exactly where it lands below
      the hero: it never travels up the screen, the page simply slides away
      beneath it (reads as moving down), it sticks, and it only leaves when
      its section hands over to the chapter grid.
   4. Nav chrome — the bar is visible from landing: transparent over the
      hero (white + and icons, empty logo slot). The moment the wordmark
      inverts white to black at the hero's end, the bar turns solid ivory
      and the black header logotype takes over (.bs-nav-solid via CSS).
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var reduced = false;
  try {
    reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  /* ── 1. PDP sticky panel ─────────────────────────────────────────────── */
  function fixCppSticky() {
    var panels = document.querySelectorAll('.cpp-information');
    if (!panels.length) return;

    panels.forEach(function (panel) {
      if (window.innerWidth <= 989) {
        panel.style.top = '';
        return;
      }
      var navH = 89;
      var header = document.querySelector('.header');
      if (header && header.offsetHeight) navH = header.offsetHeight;

      var top = Math.min(navH, window.innerHeight - panel.offsetHeight - 24);
      panel.style.top = top + 'px';
    });
  }

  /* ── 2. Hero logotype shrink (homepage slideshow content image) ──────── */
  var heroImg = null;
  var heroSection = null;
  var heroNatH = 0; /* natural rendered height of the wordmark */
  var heroNatCY = 0; /* document-space natural centre Y */

  function findHero() {
    /* the wordmark lives in the slideshow's content image, or in the
       two-image split section's hero logo overlay when that section is
       the homepage hero instead */
    heroImg = document.querySelector(
      '.slideshow__custom-content-image-img, .two-up__hero-logo-img'
    );
    heroSection = heroImg ? heroImg.closest('.shopify-section') : null;
    if (heroImg) {
      /* homepage marker: scopes the nav fade-in CSS to the hero page */
      document.documentElement.classList.add('bs-home-hero');
      /* soft colour swap + handover; never transition the transform */
      heroImg.style.transition = 'filter 0.25s ease, opacity 0.2s ease';
    }
  }

  function measureHero() {
    if (!heroImg) return;
    var y = window.scrollY || document.documentElement.scrollTop;
    var prev = heroImg.style.transform;
    heroImg.style.transform = 'none';
    var r = heroImg.getBoundingClientRect();
    heroImg.style.transform = prev;
    if (r.height > 1) {
      heroNatH = r.height;
      heroNatCY = r.top + y + r.height / 2;
    }
  }

  function heroShrink() {
    if (!heroImg || !heroSection) return;
    var y = window.scrollY || document.documentElement.scrollTop;
    var hh = heroSection.offsetHeight || 600;

    /* the header logotype defines the exact resting size and spot */
    var headerEl = document.querySelector('.header');
    var headerH = (headerEl && headerEl.offsetHeight) || 89;
    var headerLogo = document.querySelector('.header__logo-image.bs-logotype');
    var targetH = 19;
    if (headerLogo) {
      var lh = headerLogo.getBoundingClientRect().height;
      if (lh > 1) targetH = lh;
    }
    var headerCenterY = headerH / 2;

    /* nav chrome state: the bar is visible from landing — transparent over
       the hero with an empty logo slot — and turns solid (ivory, black
       logotype) at the exact moment the wordmark inverts white to black.
       The hero RUN extends past the slideshow through any two-image split
       sections sitting directly beneath it, so the transparent bar and the
       white logotype carry on over those images too. */
    var heroBottomDoc = heroSection.getBoundingClientRect().bottom + y;
    var runEl = heroSection;
    var nextEl = runEl.nextElementSibling;
    while (
      nextEl &&
      nextEl.classList &&
      nextEl.classList.contains('shopify-section--two-up-images')
    ) {
      runEl = nextEl;
      nextEl = runEl.nextElementSibling;
    }
    var runBottomDoc = runEl.getBoundingClientRect().bottom + y;

    /* docked: the slideshow itself has scrolled past — the wordmark hands
       over to the header's WHITE logotype (same spot, same size), because
       the slideshow can clip the riding wordmark once it leaves the screen.
       inverted: the whole hero run has scrolled past — solid ivory bar,
       black logotype. With nothing after the slideshow the two moments
       coincide, which is exactly the previous behaviour. */
    var docked = y >= heroBottomDoc - headerCenterY - targetH;
    var inverted = y >= runBottomDoc - headerCenterY - targetH;
    var xHeader = document.querySelector('x-header');
    if (xHeader) {
      xHeader.classList.toggle('bs-nav-solid', inverted);
      xHeader.classList.toggle('bs-nav-white-logo', docked && !inverted);
    }

    /* the hero's bottom captions reveal the moment the logo starts
       shrinking, and hide again back at the very top */
    document.documentElement.classList.toggle('bs-hero-scrolled', y > 4);

    if (reduced) return;
    if (!heroNatH) measureHero();
    if (!heroNatH) return;
    var sEnd = targetH / heroNatH;

    /* glide the centre straight to the header spot, arriving mid-hero so it
       visibly RESTS there in white, then stays pinned on screen. The glide
       distance is capped at one viewport so a taller hero (the split
       section stacks two full screens on mobile) docks on the same beat
       as the slideshow did. */
    var glideH = Math.min(hh, window.innerHeight || hh);
    var t = Math.min(1, Math.max(0, y / (glideH * 0.55)));
    var visualCenter = heroNatCY + (headerCenterY - heroNatCY) * t;
    var ty = visualCenter - heroNatCY + y;
    var s = 1 + (sEnd - 1) * t;
    heroImg.style.transform =
      'translateY(' + ty.toFixed(2) + 'px) scale(' + s.toFixed(4) + ')';

    /* white over the hero photo; when the slideshow scrolls past the
       wordmark hands over to the nav's own logotype in the same spot and
       size — white while the hero run continues, black from the invert */
    heroImg.style.filter = inverted ? 'brightness(0)' : '';
    heroImg.style.opacity = docked && xHeader ? '0' : '1';
  }

  /* ── 3. Statement pin (homepage landing line) ────────────────────────── */
  var stmtSect = null;
  var stmtEl = null;

  function findStatement() {
    stmtSect = document.querySelector('[id$="__brand_statement_NXnt4i"]');
    stmtEl = stmtSect ? stmtSect.querySelector(':scope > div') : null;
  }

  function setStatementPin() {
    if (!stmtSect || !stmtEl) return;
    /* The pin now comes entirely from the CSS: sticky top 32vh on desktop,
       static on mobile. Clear any inline values so the stylesheet is the
       single source of truth, and the section's height decides how long
       the line sticks before the chapter grid carries it off. */
    stmtEl.style.transform = '';
    stmtEl.style.top = '';
  }

  function onScroll() {
    heroShrink();
  }

  /* ── init ────────────────────────────────────────────────────────────── */
  function lateFix() {
    fixCppSticky();
    setStatementPin();
    measureHero();
    heroShrink();
  }

  function init() {
    findHero();
    findStatement();
    fixCppSticky();
    setStatementPin();
    onScroll();
    /* late layout shifts (fonts, images, app embeds) */
    setTimeout(lateFix, 600);
    setTimeout(lateFix, 1600);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    fixCppSticky();
    setStatementPin();
    measureHero();
    onScroll();
  });
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* variant / accordion interactions can change panel height */
  document.addEventListener('change', function () {
    setTimeout(fixCppSticky, 60);
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('summary')) {
      setTimeout(fixCppSticky, 60);
    }
  });
})();
